var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import './SelectionTable.scss';
import classNames from 'classnames';
import { getDirectParent } from '@lib/popups';
import { SelectionInfo } from './SelectionInfo';
import { SonarTable } from '@ui/SonarTable';
import { Col, Row } from 'antd';
import { Else, If, Then, When } from 'react-if';
import React, { useCallback, useMemo } from 'react';
import { useCurrentUser } from '@hooks';
function getCellFromElement(element) {
    if (element.tagName === 'TD') {
        return element;
    }
    if (element.parentElement) {
        return getCellFromElement(element.parentElement);
    }
    return null;
}
function SelectionTableInner(_a, ref) {
    var { actionBar, isActionBarAbove = true, bordered, className, columns, dataSource, emptyLabel, hideSelection, forceShowSelection, id, onEditSelection, onRowClick, 
    // eslint-disable-next-line react/jsx-no-useless-fragment
    renderRow = () => React.createElement(React.Fragment, null), scroll, selectionData, selectionType } = _a, rest = __rest(_a, ["actionBar", "isActionBarAbove", "bordered", "className", "columns", "dataSource", "emptyLabel", "hideSelection", "forceShowSelection", "id", "onEditSelection", "onRowClick", "renderRow", "scroll", "selectionData", "selectionType"]);
    const { handleTablePageSelectAll, handleTableRowSelect, pageSelectedKeys, resetSelection, selectAll, selectedCount, selectAllEnabled, selectedKeys, totalCount } = selectionData;
    const { isReadOnly } = useCurrentUser();
    const isMultiColumn = Number(columns === null || columns === void 0 ? void 0 : columns.length) > 1;
    const tableLocale = useMemo(() => {
        const result = emptyLabel ? { emptyText: emptyLabel } : undefined;
        return result;
    }, [emptyLabel]);
    const handleRowConfig = useCallback((record, index) => ({
        onClick: (e) => {
            const cell = getCellFromElement(e.target);
            const isSelectionCell = cell === null || cell === void 0 ? void 0 : cell.classList.contains('ant-table-selection-column');
            if (!isSelectionCell && onRowClick) {
                onRowClick(record, index);
            }
        }
    }), [onRowClick]);
    const selectionInfoActive = selectAllEnabled || Boolean(selectedKeys.length);
    const getSelectionInfo = useCallback(() => React.createElement(If, { condition: selectionInfoActive || isMultiColumn },
        React.createElement(Then, null,
            React.createElement(Row, null,
                React.createElement(Col, { span: isActionBarAbove ? 24 : 12 },
                    React.createElement(SelectionInfo, { active: selectionInfoActive, afterClose: resetSelection, bordered: isMultiColumn && !onEditSelection, id: id, onEdit: onEditSelection, onSelectAll: selectAll, selectedCount: selectedCount, selectionType: selectionType, totalCount: totalCount !== null && totalCount !== void 0 ? totalCount : 0 })),
                React.createElement(Col, { span: isActionBarAbove ? 0 : 12 }, !isActionBarAbove && actionBar))),
        React.createElement(Else, null, selectionType)), [
        id,
        isMultiColumn,
        onEditSelection,
        resetSelection,
        selectAll,
        selectedCount,
        selectionInfoActive,
        selectionType,
        totalCount,
        actionBar,
        isActionBarAbove
    ]);
    const renderColumns = useMemo(() => columns || [
        {
            render: (value, item) => renderRow(item),
            title: getSelectionInfo()
        }
    ], [columns, getSelectionInfo, renderRow]);
    const title = isMultiColumn && !hideSelection ? getSelectionInfo : undefined;
    const componentClassNames = classNames({ [String(className)]: Boolean(className) });
    const forceHide = typeof forceShowSelection === 'boolean' && !forceShowSelection;
    const selectionEnabled = forceShowSelection || (!isReadOnly && !forceHide);
    const tableClassNames = classNames(className, {
        bordered,
        'multi-column': isMultiColumn,
        'selection-disabled': !selectionEnabled
    });
    const rowSelection = {
        onSelect: handleTableRowSelect,
        onSelectAll: handleTablePageSelectAll,
        selectedRowKeys: pageSelectedKeys
    };
    return (React.createElement("div", { className: classNames('selection-table', componentClassNames), ref: ref },
        React.createElement(When, { condition: Boolean(actionBar) && isActionBarAbove },
            React.createElement(Row, { align: 'bottom', justify: 'space-between' }, actionBar)),
        React.createElement(SonarTable, Object.assign({ className: tableClassNames, columns: renderColumns, dataSource: dataSource, getPopupContainer: getDirectParent, locale: tableLocale, onRow: handleRowConfig, pagination: false, rowClassName: onRowClick ? 'clickable' : '', rowSelection: selectionEnabled ? rowSelection : undefined, scroll: Object.assign({ y: 'content' }, scroll), title: title }, rest, { bordered: false }))));
}
export const SelectionTable = React.forwardRef(SelectionTableInner);
